module.exports = __webpack_public_path__ + "img/Products.2054d7be.svg";